import React from 'react'
import PropTypes from 'prop-types'

const Header = (props) => (
    <header id="header" style={props.timeout ? { display: 'none' } : {}}>
        <div className="logo">
            <span className="icon fa-diamond"></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Jax Hack 2019</h1>
                <p>A Bold Hackathon for a Bold City.</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => { props.onOpenArticle('intro') }}>What</a></li>
                <li><a href="javascript:;" onClick={() => { props.onOpenArticle('whenwhere') }}>When & Where</a></li>
                <li><a href="javascript:;" onClick={() => { props.onOpenArticle('team') }}>Team Signup</a></li>
                <li><a href="javascript:;" onClick={() => { props.onOpenArticle('sponsor') }}>Sponsors</a></li>
                <li><a href="javascript:;" onClick={() => { props.onOpenArticle('contact') }}>Contact</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
